import { useState } from "react";
import {
    Box,
    Checkbox,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Typography,
} from "@mui/material";

import type { ClientExpoClientObjectRow } from "../../../lib/api/types";
import { formatDate } from "./utils";

interface ExpoClientObjectsCardProps {
    rows: ClientExpoClientObjectRow[];
}

export default function ExpoClientObjectsCard({ rows }: ExpoClientObjectsCardProps) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const paginatedRows = rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <Paper className="table-card" elevation={0}>
            <Box className="table-card__header">
                <Box>
                    <Typography variant="h5">Обекти на клиенти</Typography>
                    <Typography variant="body2" color="text.secondary">

                    </Typography>
                </Box>
            </Box>
            <Box className="table-card__scroller">
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>№</TableCell>
                            <TableCell>Клиент</TableCell>
                            <TableCell>Обект</TableCell>
                            <TableCell>Потребител</TableCell>
                            <TableCell>Търговец</TableCell>
                            <TableCell>Маршрут</TableCell>
                            <TableCell align="center">Активен</TableCell>
                            <TableCell>Активност</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={8}>
                                    <Typography color="text.secondary">
                                        Няма регистрирани Expo обекти за този клиент.
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            paginatedRows.map((row) => (
                                <TableRow key={`${row.objectId}-${row.objectName}`} hover>
                                    <TableCell>{row.objectId}</TableCell>
                                    <TableCell>{row.partnerCompany || row.clientName || "—"}</TableCell>
                                    <TableCell>{row.objectName || "—"}</TableCell>
                                    <TableCell>{row.expoUsername || "НЯМА"}</TableCell>
                                    <TableCell>{row.traderName || "—"}</TableCell>
                                    <TableCell>{row.routeName || "—"}</TableCell>
                                    <TableCell align="center">
                                        <Checkbox size="small" checked={row.isActive} disabled />
                                    </TableCell>
                                    <TableCell>
                                        {row.lastActivityAt
                                            ? formatDate(row.lastActivityAt)
                                            : row.orderCount > 0
                                              ? `${row.orderCount} поръчки`
                                              : "НЯМА"}
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </Box>
            <TablePagination
                component="div"
                count={rows.length}
                page={page}
                onPageChange={(_, nextPage) => setPage(nextPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(event) => {
                    setRowsPerPage(Number(event.target.value));
                    setPage(0);
                }}
                rowsPerPageOptions={[10, 25, 50]}
                labelRowsPerPage="Редове"
            />
        </Paper>
    );
}
